import * as Logger from "js-logger";
import AnimationManager from "slotworks/graphics/animation/animation-manager";
import CanvasManager from "slotworks/graphics/canvas/canvas-manager";
import ParticleManager from "slotworks/graphics/particles/particle-manager";
import SoundManager from "slotworks/sound/sound-manager";
import { AddWindowFocusChangeLsitener } from "slotworks/utils/browser-utils";
import Contract from "slotworks/utils/contract";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import Stats = require("stats.js");
class GameLoop {

    private stats: Stats;

    // private pixiTicker: PIXI.ticker.Ticker;

    private adjustedTime: number = null;
    private lastTime: number = null;
    private pauseOffset: number = 0;

    private paused: boolean;
    private autoPaused: boolean;

    private forcedFrameDrops: number = 0;
    private fakeFps: number = 60;
    private speed: number = 1;
    private frameSkipping: boolean = true;
    private actualTime: number;

    private frameRate: number = 60;
    private desiredMSBetweenFrames: number = 1000 / this.frameRate;

    public init() {

        this.stats = new Stats();

        AddWindowFocusChangeLsitener((focus: boolean) => { this.changeFocus(focus); });

        (TweenJS as any).now = () => {
            return this.adjustedTime;
        };

        // this.pixiTicker = PIXI.ticker.shared;

        return new Contract<void>((resolve) => {
            requestAnimationFrame((time?: number) => {
                this.render(time);

                resolve(null);
            });
        });
    }

    public showStats() {
        this.stats.showPanel(0);
       // document.body.appendChild(this.stats.dom);
    }

    /**
     * Sets a manual pause on the game. If called without arguments, pause will toggle
     *
     * @param paused {boolean}
     */
    public setPaused(paused: boolean = null) {
        if (paused === null) {
            this.paused = !this.paused;
        } else {
            this.paused = paused;
        }

        if (!this.paused) {
            this.autoPaused = true;
        }

        this.log(this.paused ? "paused" : "unpaused");
    }

    public isPaused() {
        return this.paused;
    }

    public setSpeed(speed: number) {
        this.speed = speed;
        this.desiredMSBetweenFrames = 1000 / this.frameRate * this.speed;
    }

    private changeFocus(focus: boolean) {
        if (!focus) {
            this.autoPaused = true;
            SoundManager.unfocus();
        } else {
            SoundManager.focus();
        }
    }

    private render(time?: number) {

        if (time) {
            time = time * this.speed;
            
            this.actualTime = time;
            if (!this.frameSkipping) {
                if (time - this.lastTime > this.desiredMSBetweenFrames) {
                    time = this.lastTime + this.desiredMSBetweenFrames;
                }
            }
        }

        this.forcedFrameDrops++;

        if (!this.fakeFps || this.forcedFrameDrops >= (this.frameRate / this.fakeFps)) {
            this.forcedFrameDrops = 0;

            this.stats.begin();

            if (this.adjustedTime === null) {
                this.adjustedTime = time;
            }

            if (this.autoPaused || this.paused) {

                if (this.lastTime === null) {
                    this.lastTime = time;
                }
                this.pauseOffset += time - this.lastTime;
                this.autoPaused = false;

            }

            if (!this.autoPaused && !this.paused) {
                this.adjustedTime = time - this.pauseOffset;
                // if (this.lastTime - this.adjustedTime)

                AnimationManager.update(this.adjustedTime);
                TweenJS.update();
                Timer.update(this.adjustedTime);
                ParticleManager.update(this.actualTime - this.pauseOffset);
            }

            CanvasManager.renderer.render(CanvasManager.stage);

            this.lastTime = time;

            this.stats.end();
        }

        requestAnimationFrame((t: number) => this.render(t));
    }

    /**
     * Log a message with colored label
     *
     * @param message {string}
     */
    private log(message: string) {
        Logger.info("%c Game Loop ", "background: #f77bed; color: #fff", message);
    }
}

export default new GameLoop();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/core/game-loop.ts